import { LOANS } from "../../../constants/constants";
import { useTitle } from "../../../hooks/common/useTitle";
import { ListHandler } from "../../lists/ListHandler";

export const LoansPage = () => {
  useTitle(LOANS);
  return (
    <div className="p15">
      <ListHandler source={LOANS} />
    </div>
  );
};
